import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div name="home" className=" w-full h-screen ">
      {/* container */}
      <div className="max-w-[1000px] mx-auto px-4   flex flex-col justify-center h-full">
        <p className="  text-xl">Hi ! My Name is </p>
        <h1 className="text-4xl sm:text-7xl py-[15px] font-bold text-[#ccd6f6]">
          Ales Mazur
        </h1>
        <h2 className="text-4xl sm:font-bold  text-[#008037] ">
          I'm a Front-end Developer{" "}
        </h2>
        <p className="text-gray-300 py-4 max-w-[500px]">
          specializing in building responsive web-applications. I always open to
          interesting proposals for collaborations.
        </p>
        <li className="px-0">
          <Link to="work" spy={true} smooth={true} offset={-90} duration={300}>
            <button className=" group text-white border-2 flex max-w-[130px] px-6 py-3 my-2 items-center justify-between hover:bg-[#008037] border-[#008037] duration-200  ">
              Works
              <span className="group-hover:rotate-90 duration-200">
                <HiArrowNarrowRight className="ml-3 block " />
              </span>
            </button>
          </Link>
        </li>
      </div>
    </div>
  );
};

export default Home;
